import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Appcues Case Study | Canny';
const Description =
  'Read about how Appcues closes the feedback loop with Canny to improve their product and customer experience.';
const Image = 'https://canny-assets.io/images/8f04d9b78a681a15822c2d2209dcb2a0.png';
const AppcuesUrl = 'https://canny.io/case-studies/appcues';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${AppcuesUrl}#webpage`,
    url: AppcuesUrl,
    name: 'Case Study: Appcues × Canny',
    description: 'How Appcues closes the feedback loop with Canny.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${AppcuesUrl}#article`,
    genre: 'Case Study',
    headline: 'How Appcues closes the feedback loop with Canny',
    description:
      'Appcues replaced a disorganized feedback system using Slack and Airtable with Canny, enabling customer-facing teams to collect, prioritize, and respond to requests efficiently—integrating Slack, Salesforce, and shortcuts within their app to streamline feedback and reconnect with users.',
    inLanguage: 'en',
    url: AppcuesUrl,
    mainEntityOfPage: { '@id': `${AppcuesUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Appcues', url: 'https://appcues.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Appcues', item: AppcuesUrl },
  ]),
]);

export default class AppcuesLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: AppcuesUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
